import React, { useState } from 'react';
import SPAButton from '../shared/SPAButton';
import SPAInput from '../shared/SPAInput';
import SPASectionHeading from '../shared/SPASectionHeading';
import { Field, panelClass } from '../shared/formPanel';
import { Limits } from './types';

interface DefaultsFormProps {
  defaults: Limits;
  isSaving: boolean;
  onSave: (daily: string, rpm: string) => void;
}

const DefaultsForm = ({ defaults, isSaving, onSave }: DefaultsFormProps) => {
  const savedDaily = defaults.daily_limit_usd == null ? '' : String(defaults.daily_limit_usd);
  const savedRpm = defaults.requests_per_minute == null ? '' : String(defaults.requests_per_minute);
  const [daily, setDaily] = useState(savedDaily);
  const [rpm, setRpm] = useState(savedRpm);

  const dirty = daily !== savedDaily || rpm !== savedRpm;
  const complete = daily.trim() !== '' && rpm.trim() !== '';

  return (
    <section>
      <SPASectionHeading meta="Saving reloads the plugin on live traffic" title="Defaults" />
      <div className={panelClass}>
        <p className="tw-mb-4 tw-mt-0 tw-text-sm tw-text-spa-secondary">
          What every identity is measured against unless it has its own limits below.
        </p>
        <div className="tw-flex tw-flex-wrap tw-items-end tw-gap-4">
          <Field className="tw-w-40" htmlFor="default-daily" label="$ / day">
            <SPAInput id="default-daily" inputMode="decimal" value={daily} onChange={e => setDaily(e.target.value)} />
          </Field>
          <Field className="tw-w-40" htmlFor="default-rpm" label="Req / min">
            <SPAInput id="default-rpm" inputMode="numeric" value={rpm} onChange={e => setRpm(e.target.value)} />
          </Field>
          <SPAButton
            disabled={!dirty || !complete || isSaving}
            variant="primary"
            onClick={() => onSave(daily, rpm)}
          >
            Save
          </SPAButton>
        </div>
      </div>
    </section>
  );
};

export default DefaultsForm;
